import React, { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { MenuItem, Select, Backdrop, CircularProgress } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import DateFnsUtils from '@date-io/date-fns'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import RoomIcon from '@mui/icons-material/Room'
import './flights.css'
import { getAuth } from '../../../utility/apiConfig'
import { API_BASE_URL } from '../../../utility/apiConstants'
import { depVali, fromVali, toVali } from './flightSearchValidation'
import { stringToDate } from '../../../core/helper'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import flightSearchReducers from '../../../store/flights/reducers/flightSearchReducers'
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }

const SpecialFare = (props) => {
  const classes = useStyles()
  const history = useHistory()

  const [depDate, setDepDate] = useState(null)
  const [classType, setClassType] = useState('Economy')
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [disableDateList, setDisableDateList] = useState([])
  const [fromAirport, setFromAirport] = useState([])
  const [fromValue, setFromValue] = useState(null)

  const [airportList, setAirportList] = useState([])

  const [isOpenDepart, setIsOpenDepart] = useState('')

  const [showPassClass, setShowPassClass] = useState(false)
  const [showTravellerCount, setShowTravellerCount] = useState(false)
  const [showPassClassBtn, setShowPassClassBtn] = useState(true)

  const togglePassClass = () => {
    setShowPassClass(!showPassClass)
  }

  const getTavellerCount = () => {
    setShowPassClassBtn(false)
    setShowTravellerCount(true)
    setShowPassClass(false)

  }

  const [oneWay, setOneWay] = useState({
    trip_type: 'oneway',
    from: '',
    from_loc_id: '',
    to: '',
    to_loc_id: '',
    depature: '',
    adult: 1,
    child: 0,
    infant: 0,
    nonStop: false,
    studentFare: false,
    search_flight: 'search',
    v_class: 'Economy',
    carrier: [],
    specialFare: true
  })

  const [oneWayError, setOneWayError] = useState({
    fromError: '',
    toError: '',
    depatureError: ''
  })

  // useEffect(()=>{
  //   if(props.initialLoad === true){
  //   getDestinationList();
  //   props.setInitialLoad(false);
  //   }
  // },[])

  // const getDestinationList = async()=>{
  //    await getAuth(API_BASE_URL + 'management/fetch_specialfare_sectors')
  //       .then((response) => {
  //         if (response.data.status) {
  //           setAirportList(response.data.data)
  //         } else {
  //           setAirportList([])
  //         }
  //       }).catch((error) => {
  //       })
  //   }

  const handleDateChange = (date) => {
    setOneWayError({ ...oneWayError, depatureError: '' })

    setDepDate(date)
    setOneWay({
      ...oneWay,
      depature: date === null ? '' : stringToDate(date)
    })
  }

  const onClickAdult = (type) => {
    if (type === 'increment') {
      if (oneWay.adult < 9) {
        setOneWay({
          ...oneWay,
          adult: oneWay.adult + 1,
          child: 0,
          infant: 0
        })
      }
    } else {
      if (oneWay.adult > 1) {
        setOneWay({
          ...oneWay,
          adult: oneWay.adult - 1,
          child: 0,
          infant: 0
        })
      }
    }
  }

  const onClickChild = (type) => {
    if (type === 'increment') {
      if (oneWay.child < (9 - oneWay.adult)) {
        setOneWay({
          ...oneWay,
          child: oneWay.child + 1
        })
      }
    } else {
      if (oneWay.child > 0) {
        setOneWay({
          ...oneWay,
          child: oneWay.child - 1
        })
      }
    }
  }

  const onClickInfants = (type) => {
    if (type === 'increment') {
      if (oneWay.infant < oneWay.adult) {
        setOneWay({
          ...oneWay,
          infant: oneWay.infant + 1
        })
      }
    } else {
      if (oneWay.infant > 0) {
        setOneWay({
          ...oneWay,
          infant: oneWay.infant - 1
        })
      }
    }
  }

  const handleClassChange = (event) => {
    setClassType(event.target.value)
    setOneWay({
      ...oneWay,
      v_class: event.target.value
    })
  }

  const handleClassClose = () => {
    setOpen(false)
  }

  const handleClassOpen = () => {
    setOpen(true)
  }


  const filterOptions = (options, state) => {
    const { inputValue } = state

    if (!inputValue) {
      return options.slice(0, 10)
    }
    const arr = props?.airportList?.filter((item) => {
      return item.source.toLowerCase() === inputValue.toLowerCase() || item.destination.toLowerCase() === inputValue.toLowerCase() || item.source_loc.toLowerCase() === inputValue.toLowerCase() || item.destination_loc.toLowerCase() === inputValue.toLowerCase()
    })

    if (arr && arr.length > 0) {
      return arr
    } else {
      const cityArr = props?.airportList?.filter((item) => {
        return item.source.indexOf(inputValue.toLowerCase()) > -1 || item.destination.indexOf(inputValue.toLowerCase()) > -1 || item.source_loc.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 || item.destination_loc.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      })
      return cityArr && cityArr.length > 0 ? cityArr.slice(0, 20) : []
    }
  }

  const fetchCalendarDates = async (from, to) => {
    setIsLoading(true);
    await getAuth(API_BASE_URL + `/management/fetch_specialfare_dates/${from}/${to}`)
      .then((response) => {
        if (response.data.status) {
          setDisableDateList(response.data.data)
          setIsLoading(false);
        } else {
          setDisableDateList([])
          setIsLoading(false);
        }
      }).catch((error) => {
        setIsLoading(false);
      })
  }

  const disableRandomDates = (date) => {
    let date1 = moment(new Date(date)).format("YYYY-MM-DD");
    let result =  (disableDateList !== null && disableDateList.length > 0) ? 
    disableDateList.filter((item) => { return item.dept_date === date1 }) : [];
    return result.length > 0 ? false : true
  }

  const oneWaySearch = () => {

    const fromEr = fromVali(oneWay.from, oneWay.to)
    const toEr = toVali(oneWay.to, oneWay.from)
    const depEr = depVali(oneWay.depature)

    if (fromEr || toEr || depEr) {
      setOneWayError({
        ...oneWayError,
        fromError: fromEr,
        toError: toEr,
        depatureError: depEr
      })
      return
    }


    history.push({
      pathname: '/flight/search',
      state: oneWay
    })
  }
  
  return (
    <div>
      <Box>
          <form className={classes.root} noValidate autoComplete="off">
            <Box className="search-wpr search-wrp-sp">
              <Grid container spacing={1} className="cntrowswp">
                <Grid item md={4} xs={12} className="prstColl mob-input-border">
                  <Box textAlign="left" className="box-tlt box-input-w">
                    <span>From</span>
                    <Autocomplete
                      className="inputFieldLocation"
                      size="small"
                      id="free-solo-demo"
                      freeSolo
                      autoComplete
                      includeInputInList
                      filterSelectedOptions
                      options={props?.airportList !== null ? props?.airportList : []}
                    //  filterOptions={filterOptions}
                      getOptionLabel={(option) => option.source_loc + " - " + option.destination_loc}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box className="searchsuggestionbox">
                            <Box className="cityfly">{option.source_loc} - {option.destination_loc}</Box>
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          placeholder="Type atleast 3 letters"
                          className="inputFieldLocation"

                          error={!!oneWayError.fromError}
                          helperText={oneWayError.fromError}

                        />
                      )}

                      // filterOptions={(x) => x}
                      value={fromValue}
                      onChange={(event, newValue) => {
                        //  setOneWay({...oneWay, from:newValue})
                        setOneWayError({ ...oneWayError, fromError: '' , depatureError: ''})
                        setFromAirport(newValue ? [newValue, ...fromAirport] : fromAirport)
                        setFromValue(newValue)
                        // setSwitchB(newValue);
                        if (newValue) {
                          setOneWay({
                            ...oneWay,
                            from: newValue.source_loc + ' (' + newValue.source + ')',
                            to: newValue.destination_loc + ' (' + newValue.destination + ')',
                          })
                          setDepDate(null);
                          fetchCalendarDates(newValue.source_loc, newValue.destination_loc);
                        }
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item md={4} xs={12} className="prstColl  mob-input-border d-flex">
                  <span className='border-right div-border-right'></span>

                  <Box textAlign="left" className="box-tlt box-input-w">
                    <span>Departure date</span>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className="inputDate"
                        size="small"
                        disableToolbar
                        variant="inline"
                        inputVariant="outlined"
                        format="EE, dd MMM yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        disablePast
                        value={depDate}
                        // onChange={handleDateChange}
                        // autoOk
                        InputProps={{ readOnly: true }}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        error={!!oneWayError.depatureError}
                        helperText={oneWayError.depatureError}
                        placeholder="Select depature date"
                        shouldDisableDate={disableRandomDates}
                        onChange={newDate => {
                          handleDateChange((disableDateList !== null && disableDateList.length > 0) ? newDate : null)
                          setIsOpenDepart((disableDateList !== null && disableDateList.length > 0) ? false : true)
                        }}
                        KeyboardButtonProps={{
                          onFocus: e => {
                            setIsOpenDepart(true)
                          }
                        }}
                        PopoverProps={{
                          disableRestoreFocus: true,
                          onClose: () => {
                            setIsOpenDepart(false)
                          }
                        }}
                        InputProps={{
                          onFocus: () => {
                            setIsOpenDepart(true)
                          }
                        }}
                        open={isOpenDepart}
                        //
                        disabled={!oneWay.from || !oneWay.to || !fromValue}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>
                </Grid>


                <Grid item md={4} xs={12} className="mob-input-border">
                  <Box textAlign="left" className="box-tlt box-input-passclass d-flex">
                    <span className='border-right div-border-right'></span>
                    <Box>
                      <span>Passengers & Class</span>
                      <h6 onClick={togglePassClass} className='trav-txt'><span className='trav-count'>{oneWay.adult + oneWay.child + oneWay.infant}</span> Travellers <p className='class-txt'>{oneWay.v_class}</p></h6>
                      {showPassClass ? (
                        <Box className='passclass-box'>
                          <Grid container spacing={1} className="rowGap">
                            <Grid item md={12}>
                              <Box>
                                <Box textAlign="left" className="box-tlt">
                                  adult (12 Yrs +)
                                </Box>
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                  className="btnGroup"
                                >
                                  <Button className="btnGroup" onClick={() => onClickAdult('decrement')}>-</Button>
                                  <Button className="btnGroup">
                                    {oneWay.adult}
                                  </Button>
                                  <Button className="btnGroup" onClick={() => onClickAdult('increment')}>+</Button>
                                </ButtonGroup>
                              </Box>
                            </Grid>
                            <Grid item md={12}>
                              <Box>
                                <Box textAlign="left" className="box-tlt">
                                  child (2 yrs - 12 Yrs)
                                </Box>
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                  className="btnGroup"
                                >
                                  <Button className="btnGroup" onClick={() => onClickChild('decrement')}>-</Button>
                                  <Button className="btnGroup">
                                    {oneWay.child}
                                  </Button>
                                  <Button className="btnGroup" onClick={() => onClickChild('increment')}>+</Button>
                                </ButtonGroup>
                              </Box>
                            </Grid>
                            <Grid item lg={12}>
                              <Box>
                                <Box textAlign="left" className="box-tlt">
                                  infant (Below 2 Yrs)
                                </Box>
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                  className="btnGroup"
                                >
                                  <Button className="btnGroup" onClick={() => onClickInfants('decrement')}>-</Button>
                                  <Button className="btnGroup">
                                    {oneWay.infant}
                                  </Button>
                                  <Button className="btnGroup" onClick={() => onClickInfants('increment')}>+</Button>
                                </ButtonGroup>
                              </Box>
                            </Grid>
                            <Grid item md={12} >
                              <Box className="divSet class-wrp py-2">
                                <Box textAlign="left" className="box-tlt">
                                  Class
                                </Box>
                                <Select
                                  labelId="demo-controlled-open-select-label"
                                  id="demo-controlled-open-select"
                                  open={open}
                                  onClose={handleClassClose}
                                  onOpen={handleClassOpen}
                                  value={classType}
                                  onChange={handleClassChange}
                                  variant="outlined"
                                  className="ClassSelector"
                                >
                                  <MenuItem className="items-list" selected={true} value="Economy">
                                    Economy
                                  </MenuItem>
                                  <MenuItem className="items-list" value="Premium Economy">
                                    Premium Economy
                                  </MenuItem>
                                  <MenuItem className="items-list" value="Business">
                                    Business
                                  </MenuItem>
                                </Select>
                              </Box>
                            </Grid>
                            <Grid item md={6} className="px-2 pt-2">
                              <Button
                                variant="contained"
                                color="primary"
                                className=""
                                onClick={getTavellerCount}
                              >
                                Apply
                              </Button>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : ""}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Grid container spacing={1}>
              <Grid item lg={4} xs={3}></Grid>
              <Grid item lg={4} xs={3}></Grid>
              <Grid item lg={4} xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  className="btnSend"
                  onClick={oneWaySearch}
                >
                  Search Flight
                </Button>
              </Grid>
            </Grid>

          </form>
        </Box>
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default SpecialFare
